import Gsap from "./../utils/Gsap";
export default function Clients() {
  return (
    <section className="py-16 md:py-24 bg-[#0B0F19]">
      <div className="container mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-3 md:px-4 py-1.5 rounded-full text-xs font-bold bg-blue-500/10 text-blue-400 uppercase tracking-widest">
          Trusted Partners
        </span>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mt-4 md:mt-6 text-white px-2">
          Trusted by Global Industry Leaders
        </h2>

        <p className="text-slate-400 max-w-2xl mx-auto mt-4 md:mt-6 text-sm md:text-lg px-2">
          We collaborate with forward-thinking companies to deliver
          transformative digital experiences.
        </p>

        <div className="mt-12 md:mt-16">
          <Gsap />
        </div>
      </div>
    </section>
  );
}
